import React from 'react';

// vibbo-clip "dibbi account gereed" (D1 opname-welcome, tabel clip, id wt_Erl3QAypqeHV).
const ONBOARDING_CLIP_URL = 'https://vibbo.nl/c/7JlelPFBi5LJtIViDjVgew6bLnXR9-yQbBTZpgHVG44';

interface OnboardingLayoutProps {
  children: React.ReactNode;
}

export function OnboardingLayout({ children }: OnboardingLayoutProps) {
  return (
    <div className="min-h-screen flex items-start lg:items-center justify-center p-4 lg:p-8" style={{ backgroundColor: '#F2F2EF' }}>
      <div className="w-full max-w-7xl">
        {/* Desktop: 70/30 layout, Mobile: stacked with video at bottom */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start">
          {/* Wizard content - 70% on desktop */}
          <div className="lg:col-span-8 order-1">
            {children}
          </div>

          {/* Video - 30% on desktop, bottom on mobile */}
          <div className="lg:col-span-4 order-2 lg:sticky lg:top-0">
            <div className="relative w-full overflow-hidden rounded-2xl" style={{ paddingTop: '100%' }}>
              <iframe
                src={ONBOARDING_CLIP_URL}
                title="Uitlegvideo: aan de slag met dibbi"
                className="absolute inset-0 w-full h-full border-0"
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
